const EventCategories = [
    'Header',
    'Footer',
    'Email',
    'BuildList',
    'Article'
]

export default EventCategories